<template>
  <div
    v-if="!conversation.id"
    class="d-flex flex-column flex-grow-1">
    <div class="d-flex align-items-center justify-content-center flex-grow-1">
      <img
        style="width: 400px"
        src="/assets/icon/dashboard-v2.svg" />
    </div>

    <MenuConversation
      ref="MenuConversation"
      v-show="isMenuVisible"
      :conversation="menuConversation"
      :profile="profile"
      :members="members"
      @addGroup="addGroup"
      @addMembers="addMembers"
      @getGroupInfo="getGroupInfo" />
  </div>
  <div
    v-else
    class="d-flex flex-grow-1">
    <div
      class="d-flex flex-grow-1 flex-column justify-content-between border-right"
      style="height: 100vh">
      <MessageBoxHeaderV2
        :countMember="members.length"
        :conversation="conversation"
        :profile="profile"
        :isExpand="isExpand"
        :online="false"
        :lastOnlineStr="''"
        :idConversationGroup="conversation"
        :members="members"
        :onlineStatus="onlineStatus"
        :pin="conversation.isPin"
        :searchKey="searchMessageInner"
        @changeSearchKey="(e) => (searchMessageInner = e)"
        @onSearchMessage="onSearchMessage"
        @onClickExpand="onExpandConversation" />
      <BlockUserV2
        v-if="!conversation.group && profile"
        :data="profile"
        :conversation="conversation" />
      <RequestFriendBoxV2
        v-if="!conversation.group && !conversation.page && profile && profileObjects.length"
        :conversation="conversation"
        :requestFriend="requestFriend"
        :data="profile" />
      <PinMessagesV2
        ref="pinComponentsV2"
        :conversation="conversation"
        :pin-messages="pinMessages"
        @onClickPinMsg="onScrollToMessage" />

      <MessageBoxV2
        class="pt-5"
        ref="messageBoxV2"
        :isExpand="isExpand"
        :conversation="conversation"
        :messageList="messageList"
        :members="members"
        :profile="profile"
        :pin-messages="pinMessages"
        :canLoadMoreAfter="canLoadMoreAfter"
        @loadLastMessage="loadLastMessage"
        @onClickBox="onClickBox"
        @loadMore="fetchMessageList"
        @pinMessage="pinMessage"
        @unPinMessage="unPinMessage"
        @showRepliedMessage="showRepliedMessage"
        @editTopic="editTopic"
        @onClickMessageReplied="onScrollToMessage"
        :readyLoadMore="readyLoadMore"
        :canLoadMore="canLoadMore" />
      <div
        class="z2-conversation-footer"
        @drop.stop.prevent="dropHandler"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false">
        <ConversationTagV2
          :conversation="conversation"
          :isExpand="isExpand" />

        <LinkPopupV2
          v-if="!showReplied && showLink"
          :data="linkObject"
          @closeLinkPopup="showLink = false" />

        <div
          ref="chatMessageReplyV2"
          v-if="showReplied"
          class="mx-1 mt-1 rounded-1 d-flex p-1"
          style="position: relative; background-color: #eaedf0">
          <img
            src="/assets/icon/icon_close_fill.svg"
            @click="closeReplied()"
            class="pointer"
            style="width: 15px; height: 15px; position: absolute; top: 6px; right: 6px" />
          <div class="divider-right ms-2"></div>
          <div class="ms-2 d-flex flex-column justify-content-around">
            <div
              class=""
              style="">
              <span class="font-13 me-1">Trả lời</span>
              <span class="fw-semibold">{{ conversation.toName }}:</span>
            </div>
            <MessageContent
              :messageRepied="true"
              :message-list="messageList"
              :message="messageReplied"
              :conversation-id="conversation.id" />
          </div>
        </div>

        <div
          v-if="!conversation.group || (!isLockSendMsg && !isRemove && conversation.group)"
          class="px-2 mx-1 border-bottom">
          <div class="flex-container-line py-1">
            <el-popover
              transition="el-fade-in-linear"
              v-model="showMention"
              :visible-arrow="false"
              placement="top-start"
              width="300"
              trigger="click">
              <div
                class="overflow-auto"
                style="max-height: 400px">
                <div
                  :key="index"
                  v-for="(item, index) in itemsInMention">
                  <div
                    class="pointer pin d-flex rounded-1 align-items-center py-2 px-1"
                    :class="selectedMention === index && 'mention-selected'"
                    @click="addMentioned(item)">
                    <el-avatar
                      class="mx-2"
                      :src="item.avatar"
                      v-if="item.id != '-1'"
                      style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
                    <div
                      class="d-flex align-items-center"
                      v-else>
                      <el-avatar
                        class="mx-2"
                        src="https://chat.zalo.me/assets/icn_mentionall.b2c245e08bb8372941a2ae03865b67e4.png"
                        style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
                      <div class="me-2">Báo cho cả nhóm</div>
                    </div>

                    <div
                      v-bind:class="item.id === '-1' ? 'c-blue' : ''"
                      class="me-2">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div slot="reference"></div>
            </el-popover>
            <el-input
              v-if="!richTextEditorMode"
              ref="inputTextV2"
              class="textarea-single"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 6 }"
              resize="none"
              placeholder="Nhập tin nhắn"
              @keydown.exact.native="handleKeyDown"
              @input="handleInput"
              v-model="newMessage"
              v-debounce:10ms.lock="checkTyping"
              v-debounce:500ms.unlock="unlockTyping"></el-input>

            <div
              v-else
              class="w-100">
              <QuillTextEditor
                :members="members"
                :conversation="conversation" />
            </div>

            <div class="d-flex align-items-center">
              <el-popover
                placement="top"
                trigger="click"
                v-model="stickerVisibleS">
                <img
                  src="../../public/assets/icon/sticker.svg"
                  slot="reference"
                  style="border: none; margin-left: 0"
                  class="p-1 pointer pin rounded-1 font-size-18 flex-1" />
                <StickerPicker
                  :dataSticker="dataSticker"
                  @sendSticker="sendSticker" />
              </el-popover>
              <el-popover
                placement="top"
                trigger="click"
                v-model="stickerVisible">
                <el-button
                  slot="reference"
                  style="border: none; margin-left: 0"
                  class="p-1 pointer pin rounded-1 v2-emoji font-size-18 flex-1" />
                <EmojiPicker />
              </el-popover>
              <el-popover
                popper-class="p-0"
                v-model="showQuickMessage"
                placement="top-end"
                width="400px"
                trigger="click">
                <!-- @show="handleQuickMessageShow" -->
                <!-- Thêm sự kiện @show -->
                <QuickReplyPopup
                  ref="quickRep"
                  :conversation="conversation"
                  @selectedMessage="selectMessage"
                  :content="newMessage"
                  @closePopup="showQuickMessage = false" />
                <el-button
                  slot="reference"
                  style="border: none; margin-left: 0"
                  class="p-1 pointer rounded-1 pin flex-1 flex-1 v2-message-auto font-size-18 me-2" />
              </el-popover>

              <el-button
                class="mb-1"
                type="primary"
                size="small"
                @click="sendMessage">
                Gửi
              </el-button>
            </div>
          </div>
          <div
            v-if="app.selectedImages.length > 0"
            class="d-flex flex-wrap"
            v-bind:style="{ height: HEIGHT_MESSAGE_PASTE + 'px', overflow: 'none' }">
            <div
              style="margin-right: 10px; margin-bottom: 10px; width: 70px; height: 70px; position: relative"
              v-for="(image, index) in app.selectedImages"
              :key="index">
              <div v-if="image.file">
                <el-image
                  v-if="image.file.type.startsWith('image/')"
                  class="rounded-2"
                  style="width: 70px; height: 70px"
                  :src="image.url"
                  fit="cover"
                  lazy></el-image>
                <div
                  v-else
                  style="width: 70px; height: 70px">
                  <el-image
                    style="width: 50px; height: 50px; margin-left: 10px"
                    src="https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg"
                    fit="cover"
                    lazy></el-image>
                  <el-tooltip
                    slot="reference"
                    effect="dark"
                    :content="image.file.name"
                    placement="top">
                    <div style="width: 70px; height: 20px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; cursor: pointer; font-weight: bold">
                      {{ image.file.name }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <el-image
                v-else
                class="rounded-2"
                style="width: 70px; height: 70px"
                :src="image.url"
                fit="cover"
                lazy></el-image>
              <i
                class="el-icon-close font-16 fw-bold z2-icon-remove-file pointer"
                @click="removeImage(index)"></i>
            </div>
            <div
              @click="$refs.filePickup.click()"
              class="pointer bg-blue100 d-flex align-items-center justify-content-center rounded"
              style="margin-bottom: 10px; width: 70px; height: 70px; position: relative">
              <IconV2
                name="v2-add"
                color="#3484F0"
                size="1.25rem" />
            </div>
            <input
              style="display: none; width: 0; height: 0"
              ref="filePickup"
              type="file"
              multiple
              @change="filePickupMore" />
          </div>
        </div>

        <div
          v-if="!conversation.group || (!isLockSendMsg && !isRemove && conversation.group)"
          class="d-flex align-items-center justify-content-start px-2 py-1">
          <div>
            <input
              style="display: none; width: 0; height: 0"
              ref="file"
              type="file"
              multiple
              @change="fileSelected" />
            <el-tooltip
              effect="dark"
              content="Đính kèm file"
              placement="top">
              <el-button
                @click="$refs.file.click()"
                style="border: none; margin-left: 0"
                class="p-1 me-1 pointer rounded-1 pin v2-attachment font-size-18" />
            </el-tooltip>
          </div>

          <el-tooltip
            effect="dark"
            content="Thư viện hình ảnh"
            placement="top">
            <el-button
              @click="showLibrary = true"
              style="border: none; margin-left: 0"
              class="p-1 me-1 pointer rounded-1 pin v2-image font-size-18" />
          </el-tooltip>

          <el-tooltip
            effect="dark"
            content="Nhắc hẹn"
            placement="top">
            <el-button
              @click="showCreatePopup()"
              style="border: none; margin-left: 0"
              class="p-1 me-1 pointer rounded-1 pin v2-clock font-size-18" />
          </el-tooltip>

          <el-tooltip
            effect="dark"
            content="Định dạng tin nhắn"
            placement="top">
            <el-button
              @click="richTextEditorMode = !richTextEditorMode"
              style="border: none; margin-left: 0"
              class="p-1 me-1 pointer rounded-1 pin font-size-18">
              <img
                class="mt-1"
                style="width: 20px; filter: invert(66%) sepia(7%) saturate(504%) hue-rotate(192deg) brightness(91%) contrast(87%)"
                src="../../public/assets/icon/text-editor-icon.png" />
            </el-button>
          </el-tooltip>

          <el-popover
            v-if="!conversation.group"
            v-model="showBusinessCard"
            placement="top-start"
            width="300"
            trigger="click">
            <BusinessCardV2
              v-if="showBusinessCard"
              :conversation="conversation"
              @sendBusinessCard="sendBusinessCardList" />

            <el-tooltip
              effect="dark"
              content="Danh thiếp"
              slot="reference"
              placement="top">
              <el-button
                v-if="!conversation.group"
                style="border: none; margin-left: 0"
                class="p-1 pointer rounded-1 pin flex-1 d-flex align-items-center justify-content-center">
                <IconV2
                  name="v2-personal-contact"
                  size="18px" />
              </el-button>
            </el-tooltip>
          </el-popover>

          <el-tooltip
            effect="dark"
            content="Tạo khoản thu"
            slot="reference"
            placement="top">
            <el-button
              style="border: none; margin-left: 0"
              class="p-1 pointer rounded-1 pin d-flex align-items-center justify-content-center"
              @click="dialogCreateDebt = true">
              <img src="/assets/images/qr_code.svg" />
            </el-button>
          </el-tooltip>
        </div>

        <div
          v-if="conversation.group && isLockSendMsg"
          style="height: 48px; background-color: #f4f5f9"
          class="font-14 fw-400 text-grey600 d-flex align-items-center px-12">
          <IconV2
            class="me-1"
            style="margin-top: 2px"
            name="v2-info1"
            color="#DEB00C" />
          <span>
            Chỉ
            <span style="color: #3484f0 !important">trưởng nhóm hoặc phó nhóm</span>
            được gửi tin nhắn vào nhóm.
          </span>
          <a
            class="ms-1"
            href="https://help.zalo.me/huong-dan/chuyen-muc/tro-chuyen-nhom/tai-sao-ban-khong-the-nhan-tin-trong-mot-so-nhom-zalo/"
            target="_blank">
            Tìm hiểu thêm
          </a>
        </div>

        <div
          v-if="conversation.group && !isLockSendMsg && isRemove"
          class="msg-input d-flex align-items-center p-1">
          <p
            class="mx-auto"
            style="font-size: 16px; color: red">
            Bạn đã rời khỏi nhóm này!
          </p>
        </div>

        <!-- <div>Message link</div> -->
        <!-- <div>Message tag</div> -->
        <!-- <div>Message reply</div> -->
        <!-- <div>Message template (tin nhan mau)</div> -->
        <!-- <div>Message image (tin nhan mau)</div> -->
      </div>
    </div>

    <ConversationTabV2
      :isExpand="isExpand"
      :isSearching="isSearching"
      :searchId="searchId"
      :searchMessageInner="searchMessageInner"
      :conversation="conversation"
      :profile="profile"
      :members="members"
      :pendingMems="pendingMems"
      :isRemove="isRemove"
      :messageMedia="messageMedia"
      :messageFile="messageFile"
      :messageLink="messageLink"
      :isCanDeleteGroup="isCanDeleteGroup"
      :searchMessageData="searchMessageData"
      @onSelectMessage="onSelectMessageSearch"
      @updateSearchDateRange="updateSearchDateRange"
      @closeSearching="closeSearching"
      @getGroupInfo="getGroupInfo" />

    <!-- <div>Icon new message</div> -->

    <!-- <div>Dialog share message</div> -->
    <!-- <div>Dialog bad word</div> -->
    <!-- <div>Dialog nhắc hẹn</div> -->

    <DialogCreateTopic
      v-if="createTopic"
      :conversation="conversation"
      @close="createTopic = false"
      @created="createNewTopic" />

    <DialogEditTopic
      v-if="topicMessageEdit"
      :conversation="conversation"
      :message="topicMessageEdit"
      @close="topicMessageEdit = null" />

    <DialogBadWord
      v-if="replaceBadWord.show"
      :dataBadWord="replaceBadWord"
      :newMessage="newMessage"
      :accountId="conversation.accountId"
      @sendReplace="sendReplace"
      @close="closeReplaceBadWord" />
    <!-- <div>Dialog bình chọn</div> -->

    <DialogImageLibrary
      v-if="showLibrary"
      @close="showLibrary = false"
      :conversation="conversation" />

    <MenuConversation
      ref="MenuConversation"
      v-show="isMenuVisible"
      :conversation="menuConversation"
      :profile="profile"
      :members="members"
      @addGroup="addGroup"
      @addMembers="addMembers"
      @getGroupInfo="getGroupInfo" />

    <DialogManageDebt
      v-if="dialogCreateDebt"
      :conversation="conversation"
      @close="dialogCreateDebt = false"
      @created="onCreatedDebt"
      @sendQR="sendQRCode" />
  </div>
</template>

<script>
import MessageBoxHeaderV2 from "./MessageBoxHeaderV2.vue";
import MessageBoxV2 from "./MessageBoxV2.vue";
import ConversationTagV2 from "./ConversationTagV2.vue";
import MessageContent from "./message/MessageContent.vue";
import EmojiPicker from "./message/EmojiPicker";
import LinkPopupV2 from "./message/LinkPopupV2";
import PinMessagesV2 from "./message/PinMessagesV2";
import RequestFriendBoxV2 from "./message/RequestFriendBoxV2.vue";
import BlockUserV2 from "./message/BlockUserV2.vue";
import DialogCreateTopic from "./message/DialogCreateTopic.vue";
import DialogEditTopic from "./message/DialogEditTopic.vue";
import DialogBadWord from "@/components/DialogBadWord";
// import DialogCreateDebt from "./Debt/DialogCreateDebt.vue";
import DialogManageDebt from "./Debt/DialogManageDebt.vue";
import DialogImageLibrary from "./DialogImageLibrary.vue";
import QuickReplyPopup from "../components/QuickReplyPopup";
import ConversationTabV2 from "./ConversationTabV2.vue";
import { convertData } from "../lib/conversation";
import IconV2 from "./common/IconV2.vue";
import { COMMON } from "../lib/Common";
import { isObjectEmpty } from "../lib/conversation";
import moment from "moment";
// import { removeVietnameseTones } from "../lib/text-utils";
import MenuConversation from "./Popup/MenuConversation.vue";
import BusinessCardV2 from "./BusinessCardV2.vue";
import { generateRandomString } from "../lib/text-utils";
import QuillTextEditor from "./common/QuillTextEditor.vue";
import StickerPicker from "./message/StickerPicker.vue";

export default {
  props: {
    conversation: Object || null,
    searchKeyMessage: String,
  },
  components: {
    MessageBoxHeaderV2,
    MessageBoxV2,
    MessageContent,
    ConversationTagV2,
    IconV2,
    EmojiPicker,
    QuickReplyPopup,
    LinkPopupV2,
    PinMessagesV2,
    DialogBadWord,
    RequestFriendBoxV2,
    BlockUserV2,
    DialogCreateTopic,
    MenuConversation,
    ConversationTabV2,
    BusinessCardV2,
    DialogImageLibrary,
    DialogEditTopic,
    // DialogCreateDebt,
    DialogManageDebt,
    QuillTextEditor,
    StickerPicker,
  },
  data() {
    return {
      isMenuVisible: false,
      menuConversation: {},

      messageTyping: "",
      newMessage: "",
      showQuickMessage: false,
      stickerVisible: false,
      stickerVisibleS: false,
      showLink: false,
      linkObject: {},
      showReplied: false,
      HEIGHT_MESSAGE_REPLIED: 60,
      HEIGHT_MESSAGE_PASTE: 75,
      HEIGHT_MESSAGE_LINK: 100,
      isDragging: false,
      isExpand: false,
      messageMedia: [],
      messageFile: [],
      messageLink: [],
      infoTab: "info",
      quickStart: [],
      createTopic: false,
      topicMessageEdit: null,

      pinMessages: [],

      // Info message box
      onlineStatus: { online: false, lastOnlineStr: "" },
      nextTime: "",
      messageList: [],
      PAGE_SIZE: 30,
      readyLoadMore: false,
      canLoadMore: true,
      canLoadMoreAfter: false,

      messageReplied: {},
      members: [],
      pendingMems: [],
      isRemove: false,
      isCanDeleteGroup: false,
      listMentions: [],
      showMention: false,
      searchTextMention: "",
      selectedMention: 0,

      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },

      profile: {},

      settingGroup: {
        addMemberOnly: 0,
        banDuration: 0,
        bannFeature: 0,
        blockName: 0,
        dirtyMedia: 0,
        enableMsgHistory: 1,
        joinAppr: 0,
        lockCreatePoll: 0,
        lockCreatePost: 0,
        lockSendMsg: 0,
        lockViewMember: 0,
        setTopicOnly: 0,
        signAdminMsg: 1,
        adminIds: [],
      },

      showBusinessCard: false,
      showLibrary: false,

      requestFriend: {},

      searchMessageInner: "",
      dateRangeMessage: [],
      isSearching: false,
      isLoadingSearch: false,
      searchId: "",
      searchMessageData: {},

      dialogCreateDebt: false,
      quickMessagesCache: [],
      textContent: "",
      richTextEditorMode: false,
      dataSticker: [],
    };
  },
  computed: {
    isLockSendMsg() {
      if (!this.conversation.group) return false;
      if (this.settingGroup.lockSendMsg === 0) {
        return false;
      } else return !this.settingGroup.adminIds.includes(this.conversation.accountId);
    },
    profileObjects() {
      if (this.profile) {
        return Object.keys(this.profile);
      }
      return "";
    },

    messageListParse() {
      return this.groupMessageByTime(this.messageList);
    },
    itemsInMention() {
      let index = this.members.findIndex((s) => s.id == "-1");
      let response = JSON.parse(JSON.stringify(this.members));
      if (index === -1) {
        let item = { id: "-1", name: "All" };
        response.unshift(item);
      }
      if (this.searchTextMention) {
        let arr = response.filter((s) => {
          return s.name.toLowerCase().includes(this.searchTextMention.toLowerCase());
        });
        if (arr.length === 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showMention = false;
        }
        if (this.listMentions.length > 0) {
          return arr.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return arr;
      } else {
        if (this.listMentions.length > 0) {
          return response.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return response;
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
  },
  watch: {
    conversation() {
      if (this.conversation.id) {
        this.getInitData();
      }
    },
    showReplied() {
      this.$bus.$emit("onShowReplied", this.showReplied);
    },
    showLink() {
      this.$bus.$emit("onShowLink", this.showLink);
    },
  },
  methods: {
    // handleQuickMessageShow() {
    //   this.$refs.quickRep.getMessage();
    // },
    getTimeSlot(hour) {
      if (hour >= 0 && hour < 4) return "0-4";
      if (hour >= 4 && hour < 8) return "4-8";
      if (hour >= 8 && hour < 12) return "8-12";
      if (hour >= 12 && hour < 16) return "12-16";
      if (hour >= 16 && hour < 20) return "16-20";
      if (hour >= 20 && hour < 24) return "20-24";
      return null;
    },

    groupMessageByTime(arr) {
      let groups = {};

      let newList = [];

      arr.forEach((item) => {
        try {
          if (item.type === "timeline") return;
          let date = new Date(Number(item.ts));

          let year = date.getFullYear();
          let month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
          let day = date.getDate().toString().padStart(2, "0");

          let hour = date.getHours();

          let timeSlot = this.getTimeSlot(hour);

          let combinedKey = `${day}/${month}/${year} ${timeSlot}`;

          if (!groups[combinedKey]) {
            groups[combinedKey] = [];
          }

          groups[combinedKey].push(item);
        } catch (e) {
          console.log("🚀 ~ arr.forEach ~ e:", e);
        }
      });
      Object.keys(groups).forEach((key) => {
        try {
          if (groups[key].length) {
            const arrChild = groups[key];
            const messageTimeline = {
              ...arrChild[arrChild.length - 1],
              type: "timeline",
            };
            newList = [...newList, ...arrChild, messageTimeline];
          }
        } catch (e) {
          console.log("🚀 ~ Object.keys ~ e:", e);
        }
      });

      return newList;
    },
    async showMenu(e, conversation) {
      // if (conversation.group) {
      //   this.getGroupInfo(conversation);
      // } else {
      //   this.getProfileInfo(conversation);
      // }

      this.isMenuVisible = true;
      this.menuConversation = conversation;
      this.setPosition(e);
    },
    setPosition(event) {
      const menu = document.getElementById("context-menu-location");
      menu.style.left = `${event.clientX + 20}px`;
      if (window.innerHeight - event.clientY < 224) {
        menu.style.top = `${event.clientY - 224}px`;
      } else {
        menu.style.top = `${event.clientY}px`;
      }
    },

    async addMembers(conversation) {
      this.$emit("onSelect", conversation);
      setTimeout(async () => {
        try {
          await this.getGroupInfo(conversation);
          this.$refs.MenuConversation.dialogGroup = true;
        } catch (err) {
          console.log("err", err);
        }
      }, 500);
    },
    async addGroup(conversation) {
      this.$emit("onSelect", conversation);
      setTimeout(async () => {
        try {
          await this.getProfileInfo(conversation);
          this.$refs.MenuConversation.dialogCreateGroup = true;
        } catch (err) {
          console.log("err", err);
        }
      }, 500);
    },

    getInfoConversation(conversation) {
      this.isRemove = false;
      this.profile = {};
      this.data = {};
      this.members = [];
      this.requestFriend = {};
      this.pinMessages = [];

      this.$http.post("/api/messageV2/getConversationInfo", {
        accountId: conversation.accountId,
        toId: conversation.toId,
        group: conversation.group,
        page: conversation.page,
      });
    },

    async getInitData() {
      this.messageList = [];
      this.readyLoadMore = false;
      this.canLoadMore = true;
      this.fetchDataInfo(this.conversation);
      this.getAliasByAccountId(this.conversation);
      // this.getInfoConversation(this.conversation);
      this.getProfileInfo(this.conversation);
      this.getPinList(this.conversation);
      this.getOnlineStatus(this.conversation);
      this.getStickerCategoryDetail();
      // Hội thoại được chọn từ Tìm kiếm tin nhắn
      if (this.conversation.isConversationMessage) {
        this.nextTime = this.conversation.lastMessageTime;
        await this.fetchMessageList(false);
        await this.fetchMessageListAfter(this.conversation.lastMessageTime);
      } else {
        await this.fetchMessageList(true);
      }

      this.unread(this.conversation.id);
    },
    async fetchMessageList(first, retryCount = 0) {
      await this.$http
        .post("/api/message/filter", {
          conversationId: this.conversation.id,
          accountId: this.conversation.accountId,
          timestamp: first ? "" : this.nextTime,
          timestampAfter: "",
          pageSize: this.PAGE_SIZE,
        })
        .then((resp) => {
          if (resp.data.length > 0 && resp.data[0].id.conversationId == this.conversation.id) {
            resp.data.forEach((s) => !s.visiblePopup);
            // this.messageList.push(...resp.data);
            this.messageList = this.groupMessageByTime([...this.messageList, ...resp.data]);
            this.nextTime = resp.data[resp.data.length - 1].ts;
          }

          if (this.PAGE_SIZE !== resp.data.length) {
            this.canLoadMore = false;
          }
          this.sortMessage("new");
          this.convertToDoMessage(this.messageList);
          this.readyLoadMore = true;
          if (resp.data.length && !resp.data.filter((m) => m.msgType !== "chat.delete").length) {
            setTimeout(() => {
              this.$refs.messageBoxV2.loadMoreMessage();
            }, 1000);
          }
        })
        .catch(e => {
          console.log(e);
          if (retryCount < 1) {
            this.fetchMessageList(true, retryCount + 1);
          }
        });
    },
    async fetchMessageListAfter(ts, searchKey = "") {
      await this.$http
        .post("/api/message/filter", {
          conversationId: this.conversation.id,
          accountId: this.conversation.accountId,
          timestamp: "",
          timestampAfter: ts,
          pageSize: 15,
        })
        .then((resp) => {
          if (resp.data.length > 0 && resp.data[0].id.conversationId == this.conversation.id) {
            resp.data.forEach((s) => !s.visiblePopup);
            resp.data[0] = { ...resp.data[0], isHighlightMessage: true, keyHighlight: searchKey };
            this.messageList = this.groupMessageByTime([...resp.data, ...this.messageList]);
          }
          if (resp.data.length < 15) {
            this.canLoadMoreAfter = false;
          } else {
            this.canLoadMoreAfter = true;
          }
          this.sortMessage("new");
          this.convertToDoMessage(this.messageList);
          this.readyLoadMore = true;
          setTimeout(() => {
            this.$refs.messageBoxV2.scrollToHighlight();
          }, 500);
        });
    },
    loadLastMessage() {
      this.messageList = [];
      this.canLoadMoreAfter = false;
      this.fetchMessageList(true);
    },
    pinMessage(message) {
      this.$refs.pinComponentsV2.pinMessage(message);
    },
    unPinMessage(message) {
      this.$refs.pinComponentsV2.unPin(message);
    },
    getOnlineStatus(conversation) {
      this.$http
        .post("/api/messageV2/onlineStatus", {
          accountId: conversation.accountId,
          toId: conversation.toId,
          group: conversation.group,
          page: conversation.page,
        })
        .then((resp) => {
          if (resp.data.data) {
            this.onlineStatus = resp.data.data;
            let now = moment(new Date());
            var end = moment(this.onlineStatus.lastOnline);
            var duration = moment.duration(now.diff(end));

            let minutes = duration.asMinutes();
            let hours = duration.asHours();
            let days = duration.asDays();

            this.onlineStatus.online = false;
            if (minutes < 1) {
              this.onlineStatus.online = true;
              this.onlineStatus.lastOnlineStr = "Vừa mới truy cập";
            } else if (minutes < 60) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(minutes) + " phút trước.";
            } else if (hours < 24) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(hours) + " giờ trước.";
            } else if (days < 10) {
              this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(days) + " ngày trước.";
            }
          }
        });
    },

    EmojiPickup(emoji) {
      this.newMessage = this.newMessage.concat(emoji);
    },
    handleKeyDown(event) {
      if (!this.showMention && event.key === "Enter") {
        this.sendMessage(event);
        return;
      }

      if (this.showMention && event.key === "ArrowDown") {
        event.preventDefault();
        this.selectedMention = this.selectedMention === this.itemsInMention.length - 1 ? 0 : this.selectedMention + 1;
      } else if (this.showMention && event.key === "ArrowUp") {
        event.preventDefault();
        this.selectedMention = this.selectedMention ? this.selectedMention - 1 : this.itemsInMention.length - 1;
      } else if (this.showMention && event.key === "Enter") {
        event.preventDefault();
        this.addMentioned(this.itemsInMention[this.selectedMention]);
      }
    },
    checkTyping(val, e) {
      if (e.type == "input" && val.length > 0 && !this.typing) {
        this.typing = true;
        this.sendTypingSocket("typing");
      }
    },
    unlockTyping(val) {
      if (val.length == 0) {
        this.sendTypingSocket("stopped_typing");
        this.typing = false;
      }
    },
    sendTypingSocket(type) {
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        type: type,
        username: this.app.user.swUsername,
      };
      this.$http.post("/api/conversation/typing", request);
    },
    handleInput() {
      this.getQuickMessage();
      this.handleLink();

      if (this.conversation.group) {
        this.getMentionComponent();
      }
      this.app.listDraft.set(this.conversation.id, this.newMessage);

      if (!this.newMessage && this.app.draftMessageList[this.conversation.id]) {
        this.app.draftMessageList[this.conversation.id].content = "";
      }
    },
    loadQuickMessages(conversation) {
      const currentAccountId = conversation.accountId;
      this.quickMessagesCache = this.app.quickReplyList
        .filter((msg) => msg.accountId === "0" || msg.accountId === currentAccountId)
        .sort((a, b) => a.code.localeCompare(b.code));
    },
    getQuickMessage() {
      this.showQuickMessage = false;

      if (this.newMessage.startsWith("/")) {
        const normalizedNewMessage = this.normalizeString(this.newMessage.trim());
        const matchingMessages = this.quickMessagesCache.filter((msg) => this.normalizeString("/" + msg.code).startsWith(normalizedNewMessage));

        if (matchingMessages.length > 0) {
          this.$refs.quickRep.quickMessageListShow = matchingMessages;
          this.$refs.quickRep.filtering = true;
          this.showQuickMessage = true;
          if (matchingMessages.length === 1) {
            this.selectFirstMessage(matchingMessages[0]);
          } else {
            if (this.newMessage.endsWith(" ")) {
              const normalizedNewMessage = this.normalizeString(this.newMessage.trim());
              const exactMatch = matchingMessages.find((msg) => this.normalizeString("/" + msg.code) === normalizedNewMessage);
              if (exactMatch) {
                this.selectFirstMessage(exactMatch);
              }
            }
          }
        } else {
          this.resetQuickMessagePopup();
        }
      }
    },

    selectFirstMessage(selectedMessage) {
      this.newMessage = selectedMessage.content + " ";
      this.pushSelectImages(selectedMessage);
      this.resetQuickMessagePopup();
    },

    resetQuickMessagePopup() {
      this.showQuickMessage = false;
      this.$refs.quickRep.quickMessageListShow = [];
      this.$refs.quickRep.filtering = false;
    },
    normalizeString(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    handleLink() {
      this.newMessage = this.newMessage.trimStart();
      if (this.showReplied) return this.resetLinkDefault();

      let arrLinks = this.detectURLs(this.newMessage);
      if (arrLinks == null) return this.resetLinkDefault();

      let arrsSplit = this.splitWhiteSpace(this.newMessage);
      if (arrsSplit.length === 1 && arrLinks[0] === this.newMessage && this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
      if (arrsSplit.length > 1) {
        let index = arrsSplit.indexOf(arrLinks[0]);
        if (arrsSplit[index + 1] !== undefined) {
          if (this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
          if (![this.linkObject.href, this.linkObject.src].includes(arrLinks[0].trim())) return this.parseLink(arrLinks[0]);
        }
      }
    },
    resetLinkDefault() {
      this.showLink = false;
      this.linkObject = {};
    },
    splitWhiteSpace(item) {
      return item.split(/\s+/);
    },
    detectURLs(message) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return message.match(urlRegex);
    },
    parseLink(link) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        link: link,
      };
      this.$http.post("/api/message/parseLink", request).then((resp) => {
        if (Object.keys(resp.data).length > 0) {
          this.linkObject = resp.data.data;
          this.showLink = true;
        } else {
          this.resetLinkDefault();
        }
      });
    },
    isEmptyObject(item) {
      return Object.keys(item).length === 0;
    },
    selectMessage(message) {
      this.newMessage = message.content;
      this.showQuickMessage = false;
      this.pushSelectImages(message);
      this.$nextTick(() => {
        this.$refs.inputTextV2.focus();
      });
      this.$bus.$emit("selectQuickMessage", message);
    },
    sendMessage(event) {
      event.preventDefault();

      if (this.richTextEditorMode) {
        this.newMessage = "";
        this.$bus.$emit("sendMessageForm");
        if (this.app.selectedImages.length > 0) this.sendFileClipborad();
        return;
      }

      if (!this.newMessage.trim().length && this.app.selectedImages.length === 0) return this.alert("error", "Nhập nội dung cần gửi.");

      if (this.showReplied) {
        if (this.newMessage.trim().length > 0) this.replyMessage();
        if (this.app.selectedImages.length > 0) this.sendFileClipborad();
        return (this.showReplied = false);
      }

      if (this.newMessage.trim().length > 0) {
        if (Object.keys(this.linkObject).length > 0 && this.showLink) {
          this.sendLink(this.linkObject);
        } else {
          if (this.refactorListMentions().length > 0) {
            return this.mentioned();
          }
          this.sendTextMessage();
        }
      }
      if (this.app.selectedImages.length > 0) this.sendFileClipborad();
    },
    replyMessage() {
      let message = this.messageReplied;

      let request = {
        conversationId: this.conversation.id,
        toId: this.conversation.toId,
        accountId: this.conversation.accountId,
        message: this.newMessage,
        ownerId: message.id.uidFrom != "0" ? message.id.uidFrom : this.conversation.accountId,
        replyMsgId: message.id.msgId,
        replyMsgClientId: message.cliMsgId,
        replyMsgTs: message.ts,
      };
      let url;
      if (message.msgType === "webchat") {
        request.replyMsg = message.content;
        url = this.conversation.group ? "/api/message/replyGroupMessage" : "/api/message/replyMessage";
      } else if (message.msgType === "chat.photo") {
        let content = JSON.parse(message.content);
        content.oriUrl = content.hdUrl = content.normalUrl = content.href;
        content.thumbUrl = content.thumb;
        request.replyMsgAttach = content;
        request.group = this.conversation.group;

        url = "/api/message/replyPhoto";
      } else if (this.isLinkMessage(message)) {
        url = "/api/message/replyPhoto";
        let content = JSON.parse(message.content);
        content.type = "38";
        request.replyMsgAttach = content;
        request.group = this.conversation.group;
      }

      this.$http
        .post(url, request)
        .then(() => {})
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra ");
        })
        .finally(() => {});
      this.showReplied = false;
      this.newMessage = "";
    },
    sendFileClipborad() {
      let urlsFromQuickMessage = this.app.selectedImages.filter((s) => !s.file).map((s) => s.url);
      if (this.app.selectedImages.length === 1) {
        if (urlsFromQuickMessage.length === 1) {
          this.sendMsgPhoto(null, 0, 0, 0, this.app.selectedImages[0]?.id);
        } else {
          this.sendMsgFile(this.app.selectedImages[0].file, 0, 0, 0);
        }
      } else {
        let groupId = new Date().getTime();
        for (let i = 0; i < this.app.selectedImages.length; i++) {
          let totalItems = this.app.selectedImages.length;
          let s = this.app.selectedImages[i];
          if (s.file) {
            this.sendMsgFile(s.file, groupId, totalItems, i);
          } else {
            this.sendMsgPhoto(null, groupId, totalItems, i, s.id);
          }
        }
      }
      this.app.selectedImages = [];
    },
    async sendMsgPhoto(file, groupId, totalItems, idInGroup, idFromQuickMessage, debtId) {
      if (file && this.hasErrorSendFile(file)) return;

      if (this.conversation.group) {
        let bodyFormData = new FormData();
        bodyFormData.append("file", file);
        bodyFormData.append("accountId", this.conversation.accountId);
        bodyFormData.append("groupId", this.conversation.toId);
        if (idFromQuickMessage) {
          bodyFormData.append("id", idFromQuickMessage);
        }
        // if (debtId) {
        //   bodyFormData.append("debtId", debtId);
        // }
        this.$http.post(
          "/api/message/sendGroupMsgPhoto?groupMsgId=" + groupId + "&totalItems=" + totalItems + "&idInGroup=" + idInGroup + "&debtId=" + (debtId || ""),
          bodyFormData
        );
      } else {
        let bodyFormData = new FormData();
        bodyFormData.append("conversationId", this.conversation.id);
        bodyFormData.append("file", file);
        bodyFormData.append("accountId", this.conversation.accountId);
        bodyFormData.append("toId", this.conversation.toId);
        if (idFromQuickMessage) {
          bodyFormData.append("id", idFromQuickMessage);
        }
        // if (debtId) {
        //   bodyFormData.append("debtId", debtId);
        // }
        await this.$http.post(
          "/api/message/sendMsgPhoto?groupId=" + groupId + "&totalItems=" + totalItems + "&idInGroup=" + idInGroup + "&debtId=" + (debtId || ""),
          bodyFormData
        );
      }
    },
    sendLink(item) {
      if (item.title !== undefined && item.title.length === 0) {
        this.sendTextMessage();
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
        return;
      }

      let request = {
        conversationId: this.conversation.id,
        group: this.conversation.group,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        media: JSON.stringify(item.media),
        desc: item.desc,
        href: item.href,
        src: item.src,
        thumb: item.thumb,
        title: item.title,
        link: this.newMessage,
      };
      this.$http.post("/api/message/sendLink", request).finally(() => {
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
      });
    },
    sendTextMessage() {
      if (this.newMessage.length > 0) {
        let items = this.filterCharacter(this.conversation, this.newMessage, this.filterCharacterArr);
        if (items.length > 0) {
          this.replaceBadWord.show = true;
          this.replaceBadWord.items = items;
          this.replaceBadWordContent();
        } else {
          this.sendMesV2();
        }
      }
    },
    sendReplace({ newMessage, keys, replace }) {
      this.newMessage = newMessage;
      this.sendMesV2(keys, replace);
      this.closeReplaceBadWord();
    },
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.newMessage;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    async sendMsgFile(file, groupId, totalItems, idInGroup) {
      if (this.hasErrorSendFile(file)) return;
      var bodyFormData = new FormData();
      bodyFormData.append("conversationId", this.conversation.id);
      bodyFormData.append("file", file);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("toId", this.conversation.toId);
      bodyFormData.append("isGroup", this.conversation.group);
      if (["image/png", "image/jpeg", "image/svg", "image/gif"].includes(file["type"])) {
        await this.sendMsgPhoto(file, groupId, totalItems, idInGroup);
      } else {
        await this.sendFile(file, bodyFormData);
      }
    },
    async sendFile(file, bodyFormData) {
      let cliMsgId = new Date().getTime();
      try {
        let message = this.createNewMessageFile(cliMsgId);
        message.fileName = file.name;
        message.size = file.size;
        message.contentType = file.type;
        this.messageList.push(message);
        // this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
        this.sortMessage("new");
      } catch (e) {
        this.removeLoadingFile(cliMsgId);
      }
      try {
        await this.$http.post("/api/message/sendMsgFile", bodyFormData);
      } finally {
        this.removeLoadingFile(cliMsgId);
      }
    },
    removeLoadingFile(cliMsgId) {
      let index = this.messageList.findIndex((s) => s.cliMsgId === cliMsgId && s.msgType === COMMON.LOADING_FILE);
      if (index > -1) {
        this.messageList.splice(index, 1);
      }
    },
    sendMesV2(keys, replace) {
      if (this.conversation.group) {
        let request = {
          accountId: this.conversation.accountId,
          groupId: this.conversation.toId,
          message: this.newMessage.trim(),
          bannedKeyword: keys ? keys : [],
          replace: replace,
        };
        this.newMessage = "";
        this.$http.post("/api/message/groupMsg", request);
      } else {
        let request = {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          message: this.newMessage,
          conversationId: this.conversation.id,
          bannedKeyword: keys ? keys : [],
          replace: replace,
        };
        this.newMessage = "";
        this.$http.post("/api/message/sms", request);
      }

      this.handleDraftMessageV2();
    },
    filePickupMore() {
      // let totalItems = this.$refs.filePickup.files.length;
      this.filePickup(this.$refs.filePickup);

      this.$refs.filePickup.value = null;
    },
    fileSelected() {
      let groupId = new Date().getTime();
      let totalItems = this.$refs.file.files.length;
      if (totalItems === 1) {
        return this.sendMsgFile(this.$refs.file.files[0], 0, 0, 0);
      }
      this.$refs.file.files.forEach(async (item, index) => {
        await this.sendMsgFile(item, groupId, totalItems, index);
      });
      this.$refs.file.value = null;
    },

    removeImage(index) {
      this.app.selectedImages.splice(index, 1);
    },
    onExpandConversation() {
      this.isExpand = !this.isExpand;
      this.fetchDataInfo(this.conversation);
    },
    getAliasByAccountId(conversation) {
      if (!this.app.aliases.find(a => a.accountId === conversation.accountId && a.name !== "All")) {
        this.$http.get("/api/contact/getAliasByAccountId?accountId=" + conversation.accountId).then(resp => {
          this.app.aliases.push(...resp.data);
        });
      }
    },
    fetchDataInfo(conversation) {
      if (!this.isExpand) return;
      this.messageMedia = [];
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["chat.photo", "chat.video.msg"],
        pageSize: 6,
      });

      this.messageFile = [];
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["share.file"],
        pageSize: 3,
      });

      this.messageLink = [];
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["chat.link"],
        pageSize: 3,
      });
    },
    fetchDataMedia(conversation) {
      this.messageMedia = [];
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["chat.photo", "chat.video.msg"],
        pageSize: 6,
      });
    },
    fetchDataFile(conversation) {
      this.messageFile = [];
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["share.file"],
        pageSize: 3,
      });
    },
    fetchDataLink(conversation) {
      this.$http.post("/api/messageV2/filter", {
        conversationId: conversation.id,
        accountId: conversation.accountId,
        timestamp: "",
        msgTypes: ["chat.link"],
        pageSize: 3,
      });
    },
    showCreatePopup() {
      this.createTopic = true;
    },
    createNewTopic() {
      // if (!topic.title) {
      //   this.alert("error", "Nhập nội dung");
      //   return;
      // }
      // if (!topic.startTime) {
      //   this.alert("error", "Bạn chưa chọn thời gian");
      //   return;
      // }
      // if (new Date(topic.startTime).getTime() < new Date().getTime()) {
      //   this.alert("error", "Nhập lại thời gian");
      //   return;
      // }

      // let request = {
      //   accountId: this.conversation.accountId,
      //   toId: this.conversation.toId,
      //   startTime: new Date(this.topic.startTime).getTime(),
      //   title: this.topic.title,
      //   repeat: this.topic.repeat,
      // };
      // this.$http.post(this.conversation.group ? "/api/message/createGroupTopic" : "/api/message/createTopic", request).then((resp) => {
      //   if (resp.data.error_code === -20017) {
      //     return this.alertError("Yêu cầu không thành công vì 2 bạn chưa kết bạn trên Zalo");
      //   }
      // });
      this.createTopic = false;
    },

    handleSendByEvent(data) {
      if (data.accountId == this.conversation.accountId && data.toId == this.conversation.toId) {
        const message = this.oList.find((m) => m.id.msgId === data.msgId);
        const messageIndex = this.messageList.findIndex((m) => m.id.msgId === data.msgId);
        if (message) {
          let filter = this.app.sendByList.filter((mes) => mes.msgId == message.id.msgId);
          if (filter != null && filter.length > 0) {
            message.sendBy = filter[0].username;
            this.$set(this.messageList, messageIndex, JSON.parse(JSON.stringify(message)));
          }
        }
      }
    },

    handlePinMessageFromWebHook(message) {
      try {
        if (message.msgType === COMMON.WEBCHAT && this.isJsonString(message.content)) {
          let content = JSON.parse(message.content);
          if (content.action !== "msginfo.actionlist") return;
          let params = JSON.parse(content.params);
          let actions = params.actions[0];
          if (actions === undefined || actions === null) {
            return this.getPinList(this.conversation);
          }
          let actionType = actions.actionType;
          if ([COMMON.PIN_MESSAGE, COMMON.UNPIN_MESSAGE].includes(actionType)) {
            this.getPinList(this.conversation);
          }
        }
      } catch (err) {
        // toDo
      }
    },
    getPinList(conversation) {
      let request = {
        accountId: conversation.accountId,
        toId: conversation.toId,
        group: conversation.group,
        page: conversation.page,
      };
      this.$http.post("/api/messageV2/pinMsgList", request).then((resp) => {
        this.pinMessages = [];
        let items = conversation.group ? resp.data?.data?.items : resp.data?.data?.data;
        if (!items) return;
        items.forEach((item) => {
          let params = JSON.parse(item.params);
          params.id = item.id;
          params.type = item.type;
          params.visible = false;
          params.editTime = item.editTime;
          this.pinMessages.push(params);
        });
      });
    },
    async getProfileInfo(conversation) {
      this.data = {};
      this.$http
        .post("/api/messageV2/getProfileInfo", {
          accountId: conversation.accountId,
          toId: conversation.toId,
          group: conversation.group,
          page: conversation.page,
        })
        .then(async (resp) => {
          if (!conversation.group) {
            this.profile = resp?.data?.data ? resp.data.data.changed_profiles[conversation.toId] : {};
          } else {
            this.isRemove = false;
            this.isCanDeleteGroup = false;
            let gridInfoMap = resp.data.data?.gridInfoMap[conversation.toId];
            if (gridInfoMap) {
              const memVerList = gridInfoMap?.memVerList;
              if (!Array.isArray(memVerList)) {
                this.members = [];
                return;
              }
              const memberMap = {}; // { id: version }
              const memberIds = [];

              for (const s of memVerList) {
                const [id, ver] = s.split("_");
                memberMap[id] = ver;
                memberIds.push(id);
              }

              const aliasSet = new Set(this.app.aliases.map(a => a.id));
              this.members = this.app.aliases.filter(a => memberIds.includes(a.id));

              const missingIds = memberIds.filter(id => !aliasSet.has(id));

              const chunkSize = 498;
              for (let i = 0; i < missingIds.length; i += chunkSize) {
                const chunkIds = missingIds.slice(i, i + chunkSize);
                const chunkMap = {};
                for (const id of chunkIds) {
                  chunkMap[id] = memberMap[id];
                }
                await this.getMembers(chunkMap, conversation);
              }
              // this.members = gridInfoMap.groupMemberList;
              this.settingGroup = gridInfoMap.setting;
              this.settingGroup.adminIds = gridInfoMap.adminIds;
              this.settingGroup.adminIds.push(gridInfoMap.creatorId);

              if (this.conversation.accountId === gridInfoMap.creatorId) {
                this.isCanDeleteGroup = true;
              }
              gridInfoMap.adminIds.forEach((id) => {
                {
                  if (this.conversation.accountId === id) this.isCanDeleteGroup = true;
                }
              });
            }
            if (resp.data.data?.removedsGroup.length > 0) {
              this.isRemove = true;
              this.alert("error", "Bạn đã rời khỏi nhóm này");
            }

            // get pending mems here!
            this.$http
              .post("/api/message/pendingMemsGroup", {
                accountId: this.conversation.accountId,
                toId: this.conversation.toId,
              })
              .then((res) => {
                this.pendingMems = res.data.data.users || [];
              });
          }
        });
    },

    async handleProfileInfo(data) {
      if (data.conversationId === this.conversation.id && !isObjectEmpty(data.profileInfo)) {
        if (!this.conversation.group) {
          this.profile = data.profileInfo.data ? data.profileInfo.data.changed_profiles[this.conversation.toId] : {};
        } else {
          this.isCanDeleteGroup = false;
          const dataInfo = data.profileInfo.data;
          let gridInfoMap = dataInfo ? dataInfo.gridInfoMap[this.conversation.toId] : {};
          if (gridInfoMap) {
            const memVerList = gridInfoMap?.memVerList;
            if (!Array.isArray(memVerList)) {
              this.members = [];
              return;
            }
            const memberMap = {}; // { id: version }
            const memberIds = [];

            for (const s of memVerList) {
              const [id, ver] = s.split("_");
              memberMap[id] = ver;
              memberIds.push(id);
            }

            const aliasSet = new Set(this.app.aliases.map(a => a.id));
            this.members = this.app.aliases.filter(a => memberIds.includes(a.id));

            const missingIds = memberIds.filter(id => !aliasSet.has(id));

            const chunkSize = 498;
            for (let i = 0; i < missingIds.length; i += chunkSize) {
              const chunkIds = missingIds.slice(i, i + chunkSize);
              const chunkMap = {};
              for (const id of chunkIds) {
                chunkMap[id] = memberMap[id];
              }
              await this.getMembers(chunkMap, this.conversation);
            }
            
            // this.members = gridInfoMap.groupMemberList;
            this.settingGroup = gridInfoMap.setting;
            this.settingGroup.adminIds = gridInfoMap.adminIds;
            this.settingGroup.adminIds.push(gridInfoMap.creatorId);

            if (this.conversation.accountId === gridInfoMap.creatorId) {
              this.isCanDeleteGroup = true;
            }
            gridInfoMap.adminIds.forEach((id) => {
              {
                if (this.conversation.accountId === id) this.isCanDeleteGroup = true;
              }
            });
          }
          if (dataInfo?.removedsGroup.length > 0) {
            this.isRemove = true;
            this.alert("error", "Bạn đã rời khỏi nhóm này");
          }
        }
      }
    },
    handleFriendStatus(data) {
      if (data.conversationId === this.conversation.id && !isObjectEmpty(data.friendStatus)) {
        this.requestFriend = data.friendStatus.data;
      }
    },

    handleOnlineStatus(data) {
      if (data.conversationId === this.conversation.id && !isObjectEmpty(data.onlineStatus)) {
        this.onlineStatus = data.onlineStatus.data;
        let now = moment(new Date());
        var end = moment(this.onlineStatus.lastOnline);
        var duration = moment.duration(now.diff(end));

        let minutes = duration.asMinutes();
        let hours = duration.asHours();
        let days = duration.asDays();

        this.onlineStatus.online = false;
        if (minutes < 1) {
          this.onlineStatus.online = true;
          this.onlineStatus.lastOnlineStr = "Vừa mới truy cập";
        } else if (minutes < 60) {
          this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(minutes) + " phút trước.";
        } else if (hours < 24) {
          this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(hours) + " giờ trước.";
        } else if (days < 10) {
          this.onlineStatus.lastOnlineStr = "Truy cập " + Math.ceil(days) + " ngày trước.";
        }
      }
    },

    handlePinList(data) {
      if (data.conversationId === this.conversation.id && !isObjectEmpty(data.pinList)) {
        this.pinMessages = [];
        let items = this.conversation.group ? data.pinList.data?.items : data.pinList.data?.data;
        if (!items) return;
        items.forEach((item) => {
          let params = JSON.parse(item.params);
          params.id = item.id;
          params.type = item.type;
          params.visible = false;
          params.editTime = item.editTime;
          params.ts = item.client_msg_id;
          this.pinMessages.push(params);
        });
      }
    },

    handleFilterMessageTab(data) {
      if (data.conversationId === this.conversation.id) {
        if (data.messageType.includes("chat.photo")) {
          this.messageMedia = [];
          this.messageMedia = this.messageMedia.concat(convertData(data.messages));
        } else if (data.messageType.includes("share.file")) {
          this.messageFile = data.messages;
        } else {
          this.messageLink = data.messages;
        }
      }
    },

    sortMessage(type, clientMsgId) {
      if (clientMsgId) {
        let messageFt = this.messageList.find((p) => p.cliMsgId == clientMsgId);
        if (messageFt) {
          let undoList = this.messageList.filter((m) => m.msgType == "chat.delete" || m.msgType == "chat.undo");
          let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
          let newMes = this.parseMessageV2(messageFt, "new", undoList, filter);
          let index = this.messageList.indexOf(messageFt);
          if (index > -1) {
            this.messageList.splice(index, 1);
          }
          this.messageList.unshift(newMes);
        }
      } else {
        let undoList = this.messageList.filter((m) => m.msgType == "chat.delete" || m.msgType == "chat.undo");
        let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
        this.messageList = this.messageList.map((message) => {
          return this.parseMessageV2(message, type, undoList, filter);
        });
      }
      this.messageList = this.messageList.sort((a, b) => Number(b.ts) - Number(a.ts));
    },

    showPhoto(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              if (params.id_in_group === 0) {
                return true;
              } else {
                let id = JSON.parse(JSON.parse(message.content).params).group_layout_id;
                let id_in_group = JSON.parse(JSON.parse(message.content).params).id_in_group;

                let idsInGroup = this.messageList
                  .filter((c) => {
                    if (c.msgType === "chat.photo") {
                      let params = JSON.parse(JSON.parse(c.content).params);
                      if (params.group_layout_id) {
                        return params.group_layout_id === id;
                      }
                    }
                    return false;
                  })
                  .map((s) => JSON.parse(JSON.parse(s.content).params).id_in_group);

                if (id_in_group === Math.min(...idsInGroup)) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          }
        }
      } catch (e) {
        return true;
      }
      return true;
    },

    addMessage(message) {
      if (message.id.conversationId == this.conversation.id) {
        let filterIndex = this.messageList.findIndex((m) => m.cliMsgId == message.cliMsgId && m.id.msgId === message.id.msgId);
        if (filterIndex !== -1) {
          this.messageList.splice(filterIndex, 1);
        }
        this.handleTodoMessageFromWebhook(message, this.messageList);
        this.messageList.unshift(message);
        let clientMsgId = null;
        try {
          if (message.msgType == "chat.delete") {
            let item = JSON.parse(message.content)[0];
            clientMsgId = item.clientDelMsgId;
          }
          if (message.msgType == "chat.undo") {
            let item = JSON.parse(message.content);
            clientMsgId = item.cliMsgId;
          }
        } catch (ex) {
          //
        }
        this.sortMessage("new", clientMsgId);
        this.handlePinMessageFromWebHook(message);
        if (clientMsgId) {
          //
        } else {
          // if (message.id.uidFrom === "0") {
          //   this.$refs.ConversationBody.scrollToBottom();
          // }
          // if (message.id.uidFrom !== "0") {
          //   this.$refs.ConversationBody.onCheckScroll(true);
          // }
        }
        if (this.showIconNewMessage === false) this.unread(this.conversation.id);
      }
    },

    scrollBox(message) {
      if (message.id.uidFrom === "0") {
        this.$nextTick(() => {
          this.$refs.messageBoxV2.scrollToBottom();
        });
      }
      if (message.id.uidFrom !== "0") {
        this.$refs.messageBoxV2.onCheckScroll({}, true);
      }
    },
    handleDraftMessageV2() {
      this.handleDraftMessage(this.newMessage, this.conversation.id);
    },
    getDraftMessageHistory(conversation) {
      this.app.selectedImages = [];
      if (this.app.draftMessageList[conversation.id]) {
        this.newMessage = this.app.draftMessageList[conversation.id].content;
      } else {
        this.newMessage = "";
      }
    },
    copyFile(e) {
      // Handle the event
      this.retrieveImageFromClipboardAsBlob(
        e,
        function (imageBlob) {
          // If there's an image, display it in the canvas
          if (imageBlob) {
            // Crossbrowser support for URL
            var URLObj = window.URL || window.webkitURL;
            var url = URLObj.createObjectURL(imageBlob);
            var image = {
              file: imageBlob,
              url: url,
            };
            if (this.app.selectedImages) this.app.selectedImages.push(image);
            else {
              this.app.selectedImages = [];
              this.app.selectedImages.push(image);
            }
          }
        }.bind(this)
      );
    },
    retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
      if (pasteEvent.clipboardData == false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        // if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();

        if (typeof callback == "function") {
          callback(blob);
        }
      }
    },

    showRepliedMessage(message) {
      this.showLink = false;
      this.showReplied = true;
      this.messageReplied = message;
      this.$nextTick(() => {
        if (this.$refs.inputTextV2) {
          this.$refs.inputTextV2.focus();
        }
      });
    },
    closeReplied() {
      this.messageReplied = {};
      this.showReplied = false;
    },

    async getGroupInfo(conversation) {
      this.isRemove = false;
      const resp = await this.$http.get("/api/message/groupInfoV2", {
        params: {
          accountId: conversation.accountId,
          groupId: conversation.toId,
        },
      });
      this.isCanDeleteGroup = false;
      let gridInfoMap = resp.data.data?.gridInfoMap[conversation.toId];
      if (conversation.id == this.conversation.id) {
        if (gridInfoMap) {
          this.settingGroup = gridInfoMap.setting;
          this.settingGroup.adminIds = gridInfoMap.adminIds;
          this.settingGroup.adminIds.push(gridInfoMap.creatorId);

          if (this.conversation.accountId === gridInfoMap.creatorId) {
            this.isCanDeleteGroup = true;
          }
          gridInfoMap.adminIds.forEach((id) => {
            {
              if (this.conversation.accountId === id) this.isCanDeleteGroup = true;
            }
          });
        }
        if (resp.data.data?.removedsGroup.length > 0) {
          this.isRemove = true;
          return this.alert("error", "Bạn đã rời khỏi nhóm này");
        }

        // Lấy ds thành viên
        this.members = [];
        gridInfoMap.memberVerMap = {};
        gridInfoMap.memVerList.forEach((i) => {
          let parts = i.split("_");
          gridInfoMap.memberVerMap[parts[0]] = parts[1];
        });
        let memberMap = gridInfoMap.memberVerMap;

        let newMemberMap = {};
        if (!memberMap) return;
        for (const key of Object.keys(memberMap)) {
          let item = this.app.aliases.find((s) => s.id == key && conversation.accountId == s.accountId);
          if (item) {
            this.members.push(item);
          } else {
            newMemberMap[key] = memberMap[key];
          }
        }

        if (Object.keys(newMemberMap).length > 498) {
          const chunkSize = 498;
          for (let i = 0; i < Object.keys(newMemberMap).length; i += chunkSize) {
            let data = Object.fromEntries(Object.entries(newMemberMap).slice(i, i + chunkSize));
            await this.getMembers(data, conversation);
          }
        } else {
          await this.getMembers(newMemberMap, conversation);
        }

        // get pending mems here!
        this.$http
          .post("/api/message/pendingMemsGroup", {
            accountId: this.conversation.accountId,
            toId: this.conversation.toId,
          })
          .then((res) => {
            this.pendingMems = res.data.data.users || [];
          });
      }
    },
    async getMembers(memberMap, conversation) {
      if (Object.keys(memberMap).length === 0) return;
      let request = {
        memberMap: memberMap,
        accountId: conversation.accountId,
      };

      const resp = await this.$http.post("/api/conversation/groupMember", request);
      if (conversation.id === this.conversation.id) {
        // this.members = [];
        if (resp.data && resp.data.length > 0) {
          this.members.push(...resp.data);
          resp.data.forEach((s) => {
            if (!this.app.aliases.find((a) => a.accountId === this.app.selectedConversation.accountId && s.id === a.id)) {
              this.app.aliases.push(s);
            }
          });
        }
      }
    },
    getMentionComponent() {
      const index = this.newMessage.length;
      if (index >= 0) {
        const { keyIndex } = this.getLastKeyBeforeCaret(index);
        const searchText = this.getLastSearchText(index, keyIndex);
        if (!(keyIndex < 1 || /\s/.test(this.newMessage[keyIndex - 1]))) {
          return (this.showMention = false);
        }
        if (searchText != null) {
          this.searchTextMention = searchText;
          this.showMention = true;
        } else {
          this.restoreMention();
        }
      }
    },
    getLastKeyBeforeCaret(caretIndex) {
      let _this = this.newMessage;
      const [keyData] = ["@"]
        .map((key) => ({
          key,
          keyIndex: _this.lastIndexOf(key, caretIndex - 1),
        }))
        .sort((a, b) => b.keyIndex - a.keyIndex);
      return keyData;
    },
    getLastSearchText(caretIndex, keyIndex) {
      if (keyIndex !== -1) {
        const searchText = this.newMessage.substring(keyIndex + 1, caretIndex);
        if (!/\s/.test(searchText)) {
          return searchText;
        }
      }
      return null;
    },
    restoreMention() {
      this.showMention = false;
      this.searchTextMention = null;
      this.selectedMention = 0;
    },
    addMentioned(item) {
      let hintLens = this.searchTextMention.length;
      this.newMessage = this.newMessage.substring(0, this.newMessage.length - hintLens);
      this.newMessage = this.newMessage + item.name + " ";
      this.restoreMention();
      this.$refs.inputTextV2.focus();
      let mention = {};
      mention.name = item.name;
      mention.uid = item.id;
      this.listMentions.push(mention);
    },
    mentioned() {
      let req = {
        accountId: this.conversation.accountId,
        groupId: this.conversation.toId,
        message: this.newMessage,
        mentions: this.listMentions,
      };
      this.newMessage = "";
      this.$http
        .post("/api/message/group/mention", req)
        .then()
        .finally(() => {
          this.listMentions = [];
        });
    },
    refactorListMentions() {
      let arr = [];
      arr = this.listMentions.reduce((t, v) => {
        let name = "@" + v.name;
        if (this.newMessage.includes(name)) {
          let obj = {};
          let index = this.newMessage.indexOf(name);
          obj.name = name;
          obj.uid = v.uid;
          obj.pos = index;
          obj["length"] = name.length;
          return [...t, obj];
        } else {
          return [...t];
        }
      }, []);
      this.listMentions = arr;
      return this.listMentions;
    },
    sendBusinessCard(item) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        friendId: item,
        conversationId: this.conversation.id,
      };
      this.$http.post("/api/message/sendContact", request).then(() => {});
    },
    async sendBusinessCardList(items) {
      for (const item of items) {
        await this.sendBusinessCard(item);
      }
      this.showBusinessCard = false;
    },
    editTopic(message) {
      this.topicMessageEdit = message;
    },
    onClickBox() {
      this.messageList = this.messageList.map((m) => {
        if (!m.isHighlightMessage) return m;
        return {
          ...m,
          isHighlightMessage: false,
          keyHighlight: "",
        };
      });
    },
    onSearchMessage() {
      this.isSearching = true;
      this.isExpand = true;
      if (!this.searchMessageInner) {
        return (this.searchId = "");
      }
      this.searchId = generateRandomString(6);
      this.isLoadingSearch = true;
      this.searchMessageData = {};
      this.$http.post(this.conversation.group ? "/api/message/searchInGroup" : "/api/message/searchInConversation", {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        searchKey: this.searchMessageInner,
        dateRange: this.dateRangeMessage,
        searchId: this.searchId,
      });
    },
    closeSearching() {
      this.isSearching = false;
      this.isExpand = false;
      this.searchMessageInner = "";
      this.searchId = "";
    },
    updateSearchDateRange(dateRange) {
      this.dateRangeMessage = dateRange;
      this.isSearching = true;
      if (!this.searchMessageInner) {
        return (this.searchId = "");
      }
      this.searchId = generateRandomString(6);
      this.isLoadingSearch = true;
      this.searchMessageData = {};
      this.$http.post(this.conversation.group ? "/api/message/searchInGroup" : "/api/message/searchInConversation", {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        searchKey: this.searchMessageInner,
        dateRange: this.dateRangeMessage,
        searchId: this.searchId,
      });
    },
    onSearchAllMessage(data) {
      if (this.searchId === data.searchId) {
        this.searchId = "";
        this.searchMessageData = data;
        this.isLoadingSearch = false;
      }
    },
    async onSelectMessageSearch(message) {
      const existMessage = this.messageList.find((m) => m.id.msgId == message.lastMessageId);
      if (existMessage) {
        existMessage.isHighlightMessage = true;
        existMessage.keyHighlight = this.searchMessageData.searchKey || "";
        this.messageList = this.groupMessageByTime([...this.messageList]);
        setTimeout(() => {
          this.$refs.messageBoxV2.scrollToHighlight();
        }, 500);
      } else {
        this.messageList = [];
        this.readyLoadMore = false;
        this.canLoadMore = true;
        this.nextTime = message.lastMessageTime;
        await this.fetchMessageList(false);
        await this.fetchMessageListAfter(message.lastMessageTime, this.searchMessageData.searchKey || "");
      }
    },
    async onScrollToMessage(message) {
      let messageTarget = this.messageList.find((m) => m.cliMsgId.toString() === message.cliMsgId.toString());
      if (messageTarget) {
        messageTarget.isHighlightMessage = true;
        messageTarget.keyHighlight = "";
        this.messageList = [...this.messageList];
        this.$refs.messageBoxV2.scrollToMessage(messageTarget.id.msgId.toString());
      } else {
        this.messageList = [];
        this.readyLoadMore = false;
        this.canLoadMore = true;
        this.nextTime = message.ts;
        await this.fetchMessageList(false);
        await this.fetchMessageListAfter(message.ts, "");
      }
    },

    sendQRCode(file, debtId) {
      this.sendMsgPhoto(file, 0, 0, 0, 0, debtId);
      this.dialogCreateDebt = false;
    },

    async sendSticker(data) {
      let body = { ...data };
      body.conversationId = this.conversation.id;
      body.accountId = this.conversation.accountId;
      body.toId = this.conversation.toId;
      if (this.conversation.group) {
        this.$http.post("/api/message/groupSticker", body);
      } else {
        this.$http.post("/api/message/sticker", body);
      }
      this.stickerVisibleS = false;
    },
    async getStickerCategoryDetail() {
      this.dataSticker = [];
      try {
        const dataStick = this.app.stickerInfor.find((st) => st.accountId == this.conversation.accountId);
        if (dataStick !== undefined) {
          this.dataSticker = dataStick.dataSticker;
          return;
        }
        await this.$http.post("/api/message/sticker/full", { accountIds: [this.conversation.accountId]});
      } catch (error) {
        console.error("Error fetching sticker categories:", error);
      }
    },
    handleSticker(data) {
      this.app.stickerInfor.push(data.data);
      const dataStick = this.app.stickerInfor.find((st) => st.accountId == this.conversation.accountId);
      this.dataSticker = dataStick.dataSticker;
    },
    onCreatedDebt() {},
  },
  created() {
    // this.getInitData();

    this.$bus.$on("saveDraftMessage", () => {
      this.handleDraftMessageV2();
    });

    this.$bus.$on("selectConversationV2", (conversation) => {
      this.richTextEditorMode = false;
      this.getDraftMessageHistory(conversation);
      this.loadQuickMessages(conversation);
      if (this.$refs.pinComponentsV2) {
        this.$refs.pinComponentsV2.isShowAllPinMessages = false;
      }
      this.closeSearching();
      this.$nextTick(() => {
        this.$refs.inputTextV2.focus();
      });
    });

    this.$bus.$on("sendByEvent", (data) => {
      if (data.accountId == this.conversation.accountId && data.toId == this.conversation.toId) {
        this.messageList = this.messageList.map((message) => {
          return this.parseMessageEvent(message, "sendBy");
        });
      }
    });

    this.$bus.$on("sendByListEvent", (data) => {
      if (data.accountId == this.conversation.accountId && data.sendByList[0].data.toId == this.conversation.toId) {
        this.messageList = this.messageList.map((message) => {
          return this.parseMessageEvent(message, "sendByList");
        });
      }
    });

    this.$bus.$on("zaloReaction", (data) => {
      if (data.accountId == this.conversation.accountId && data.conversationId == this.conversation.id) {
        this.sortMessage("reaction");
      }
    });

    this.$bus.$on("zaloReactionList", (data) => {
      if (data.accountId == this.conversation.accountId && data.conversationId == this.conversation.id) {
        this.messageList = this.messageList.map((message) => {
          return this.parseMessageEvent(message, "reactionList");
        });
      }
    });

    this.$bus.$on("emoji_click", (data) => {
      this.EmojiPickup(data);
    });

    this.$bus.$on("closeDialogMember", () => {
      this.members = [];
      this.getGroupInfo(this.conversation);
    });

    this.$bus.$on("updateImageOrVideoTab", () => {
      this.fetchDataMedia(this.conversation);
    });
    this.$bus.$on("updateFileTab", () => {
      this.fetchDataFile(this.conversation);
    });
    this.$bus.$on("updateLinkTab", () => {
      this.fetchDataLink(this.conversation);
    });
    this.$bus.$on("profileInfo", (data) => {
      this.handleProfileInfo(data);
    });
    this.$bus.$on("friendStatus", (data) => {
      this.handleFriendStatus(data);
    });
    this.$bus.$on("onlineStatus", (data) => {
      this.handleOnlineStatus(data);
    });
    this.$bus.$on("pinList", (data) => {
      this.handlePinList(data);
    });
    this.$bus.$on("filterMessageTab", (data) => {
      this.handleFilterMessageTab(data);
    });
    this.$bus.$on("SearchMessageInnerDto", (data) => {
      this.onSearchAllMessage(data);
    });
    this.$bus.$on("AcceptMemsJoinGroup", (conversation) => {
      this.getGroupInfo(conversation);
    });
    this.$bus.$on("RenewLinkEvent", (data) => {
      this.messageList = this.messageList.map((ms) => {
        if (ms.actionId == data.actionId) {
          let message = JSON.parse(ms.content);
          message.href = data.url;
          let params = JSON.parse(message.params);
          params.hd = data.url;
          message.params = JSON.stringify(params);
          ms.content = JSON.stringify(message);
        }
        return ms;
      });
      this.messageMedia = this.messageMedia.map((ms) => {
        if (ms.raw.actionId == data.actionId) {
          ms.thumb = data.url;
        }
        return ms;
      });
      this.messageFile = this.messageFile.map((ms) => {
        if (ms.actionId == data.actionId) {
          let message = JSON.parse(ms.content);
          message.href = data.url;
          ms.content = JSON.stringify(message);
        }
        return ms;
      });
    });
  },
  beforeDestroy() {
    this.handleDraftMessageV2();

    this.$bus.$off("saveDraftMessage");
    this.$bus.$off("selectConversationV2");
    this.$bus.$off("emoji_click");
    this.$bus.$off("closeDialogMember");
    this.$bus.$off("updateImageOrVideoTab");
    this.$bus.$off("updateFileTab");
    this.$bus.$off("updateLinkTab");
    this.$bus.$off("profileInfo");
    this.$bus.$off("friendStatus");
    this.$bus.$off("onlineStatus");
    this.$bus.$off("pinList");
    this.$bus.$off("filterMessageTab");
    this.$bus.$off("ReplaceLinkEvent");
    this.$bus.$off("SearchMessageInnerDto");
    this.$bus.$off("StickerDetail");
    // this.$bus.$off("sendByEvent");
    window.removeEventListener("paste", this.copyFile, false);
  },
  mounted() {
    if (this.conversation.id) {
      this.getPinList(this.conversation);
      if (this.conversation.group) {
        this.getGroupInfo(this.conversation);
      } else {
        this.getProfileInfo(this.conversation);
      }
    }
    window.addEventListener("paste", this.copyFile, false);
    window.addEventListener("click", () => {
      this.isMenuVisible = false;
    });
    this.$bus.$on("StickerDetail", (data) => this.handleSticker(data));
  },
};
</script>

<style lang="scss" >
.z2-icon-remove-file {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  color: white;
}
</style>
